"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _helpers = require("../../../helpers");

var _Dropdown = _interopRequireDefault(require("../Dropdown"));

var _icons = require("../../../static/icons/icons");

var _style = require("./style");

var formatPrice = function formatPrice() {
  var price = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return "\u20AC".concat(price);
};

var formatDiscountPrice = function formatDiscountPrice(price) {
  return "- ".concat(formatPrice(price));
};

var flatServiceProducts = function flatServiceProducts(services) {
  return services.reduce(function (flatted, service) {
    return [].concat((0, _toConsumableArray2["default"])(service.products), (0, _toConsumableArray2["default"])(flatted));
  }, []);
};

var getPromoDiscount = _helpers.helpers.getPromoDiscount,
    getTotalPrice = _helpers.helpers.getTotalPrice;

var PriceBreakdown = function PriceBreakdown(_ref) {
  var bagText = _ref.bagText,
      extraBagText = _ref.extraBagText,
      free = _ref.free,
      services = _ref.services,
      promo = _ref.promo,
      promoText = _ref.promoText,
      to = _ref.to,
      totalText = _ref.totalText;
  var allProducts = flatServiceProducts(services);
  var promoDiscount = getPromoDiscount({
    products: allProducts,
    promo: promo
  });
  var totalPrice = getTotalPrice({
    products: allProducts,
    promo: promo
  });

  var renderServiceTitle = function renderServiceTitle(serviceTitle, servicePrice) {
    return _react["default"].createElement(_style.ServiceTilteRow, null, _react["default"].createElement(_style.ServiceTitle, null, serviceTitle), _react["default"].createElement(_style.IntermediatePrice, {
      className: "notranslate"
    }, formatPrice(servicePrice)));
  };

  var renderServiceDetail = function renderServiceDetail(serviceProducts) {
    return _react["default"].createElement(_style.BagsPrice, null, serviceProducts.map(function (_ref2, j) {
      var quantity = _ref2.quantity,
          price = _ref2.price;
      return _react["default"].createElement(_style.Row, {
        key: to
      }, _react["default"].createElement(_style.Info, null, _react["default"].createElement("span", {
        className: "notranslate"
      }, j === 0 ? "".concat(bagText, " - ").concat(formatPrice(price)) : "".concat(extraBagText, " - ").concat(formatPrice(price), " x ").concat(quantity)), _react["default"].createElement(_style.Price, {
        className: "notranslate"
      }, formatPrice(quantity * price))));
    }));
  };

  return _react["default"].createElement(_style.Container, {
    "data-test-id": "price-breakdown"
  }, services.map(function (_ref3) {
    var title = _ref3.title,
        products = _ref3.products;
    return _react["default"].createElement(_style.ServiceContainer, {
      key: title
    }, _react["default"].createElement(_Dropdown["default"], {
      titleComponent: renderServiceTitle(title, getTotalPrice({
        products: products
      })),
      contentComponentOpen: renderServiceDetail(products),
      contentComponentClose: _react["default"].createElement(_style.Separator, null),
      openedIcon: _icons.ICONS.DOWN,
      closedIcon: _icons.ICONS.RIGHT,
      iconSize: 10,
      expanded: services.length === 1
    }));
  }), promo && promo.code && _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_style.Row, null, _react["default"].createElement(_style.Info, null, _react["default"].createElement("span", {
    className: "notranslate"
  }, "".concat(promoText, " - ")), _react["default"].createElement("b", {
    className: "notranslate"
  }, promo.code), _react["default"].createElement(_style.IntermediatePrice, {
    className: "notranslate"
  }, formatDiscountPrice(promoDiscount)))), _react["default"].createElement(_style.Separator, null)), _react["default"].createElement(_style.Row, null, _react["default"].createElement(_style.Info, null, _react["default"].createElement(_style.TotalText, null, totalText), _react["default"].createElement(_style.TotalPrice, {
    className: "notranslate"
  }, formatPrice(free ? 0 : totalPrice)))));
};

PriceBreakdown.propTypes = {
  bagText: _propTypes["default"].string,
  extraBagText: _propTypes["default"].string,
  free: _propTypes["default"].bool,
  services: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    title: _propTypes["default"].string,
    products: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      quantity: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
      price: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
    }))
  })).isRequired,
  promo: _propTypes["default"].shape({
    code: _propTypes["default"].string,
    amount: _propTypes["default"].number
  }),
  promoText: _propTypes["default"].string,
  totalText: _propTypes["default"].string
};
PriceBreakdown.defaultProps = {
  free: false,
  promo: undefined,
  bagText: '',
  extraBagText: '',
  promoText: 'Promocode',
  totalText: 'Total'
};
var _default = PriceBreakdown;
exports["default"] = _default;